import { fetchEventSource } from '@microsoft/fetch-event-source'
import { defineStore } from 'pinia'
import { useToast } from 'vue-toastification'

import { TOAST_CONFIG } from '@/constants/toast-config.constants'
import { useDealFinishStore } from '@/store/pages/deal-finish'

const toast = useToast()

export const useNotificationStore = defineStore('notif', {
  state: () => ({
    step: null,
    error: null,
    success: null,
  }),
  actions: {
    async subDealFinish(token) {
      try {
        const self = this
        const host = localStorage.getItem('domain_api')
        await fetchEventSource(`${host ? host : process.env.VUE_APP_BACK_URL}/api/notification/making-deal`, {
          onmessage(ev) {
            let data = null
            try {
              data = JSON.parse(ev.data)
              console.log(data)
              if (data?.step === 2 && data?.success === 0) {
                self.error = true
                useDealFinishStore().status = 0
                toast.error(`Сделка № ${data?.model}: ${data.message}`, TOAST_CONFIG)
              } else if (data?.step === 2 && data?.success === 1) {
                self.success = true
                useDealFinishStore().status = data.step
                toast.success(`Сделка № ${data?.model}: ${data.message}`, TOAST_CONFIG)
              } else if (data?.step === 3) {
                toast.info(`Сделка № ${data?.model}: ${data.message}`, TOAST_CONFIG)
              }
            } catch (e) {
              console.log(e)
            }
          },
          onerror(e) {
            console.log('error ' + e)
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
})
